module.exports = __webpack_public_path__ + "static/media/kaikas.67d16112.png";